"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_COLLECTION_EVENTS = exports.SET_EVENTS = exports.DID_SHARE_EVENT = exports.WILL_SHARE_EVENT = exports.VIEW_EVENT = exports.SET_EVENT_SAVED_STATE = void 0;
var SET_EVENT_SAVED_STATE = 'events/setSavedState';
exports.SET_EVENT_SAVED_STATE = SET_EVENT_SAVED_STATE;
var VIEW_EVENT = 'events/viewEvent';
exports.VIEW_EVENT = VIEW_EVENT;
var WILL_SHARE_EVENT = 'events/willShareEvent';
exports.WILL_SHARE_EVENT = WILL_SHARE_EVENT;
var DID_SHARE_EVENT = 'events/didShareEvent';
exports.DID_SHARE_EVENT = DID_SHARE_EVENT;
var SET_EVENTS = 'events/setEvents';
exports.SET_EVENTS = SET_EVENTS;
var UPDATE_COLLECTION_EVENTS = 'collections/update_collection_events';
exports.UPDATE_COLLECTION_EVENTS = UPDATE_COLLECTION_EVENTS;
//# sourceMappingURL=actionTypes.js.map